/*
* Copyright (C) Regione Lombardia
*/
import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CoreAuthGuard } from '@core/guards/auth.guard';
import { CoreHttpInterceptor } from '@core/interceptor/http.interceptor';
import { initBlIcons } from '@core/utilities';
import { LayoutModule } from '@layout/layout.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagesModule } from '@pages/pages.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
registerLocaleData(localeIt);

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        LayoutModule,
        PagesModule,
        NgbModule,
    ],
    declarations: [
        AppComponent,
    ],
    providers: [
        CoreAuthGuard,
        {
            provide: LOCALE_ID,
            useValue: 'it'
        },
        { 
            provide: HTTP_INTERCEPTORS,
            useClass: CoreHttpInterceptor, 
            multi: true 
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initBlIcons,
            multi: true
        },
       {provide: LocationStrategy, useClass: HashLocationStrategy}
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
